howspace.widgets.textbox = (() => {
    const translationEvent = howspace.components.translator.TRANSLATION_COMPLETED + '.textboxTables';

    const wrapTables = description => {
        description.find('table').each(function () {
            const table = $(this);
            if (table.parent().hasClass('textbox-table-scroll')) return;

            table.wrap($('<div>', {
                class: 'textbox-table-scroll',
                tabindex: 0,
                role: 'region',
                'aria-label': howspace.translate('common_description')
            }));
        });
    };

    return {
        initView: widget => {
            wrapTables(widget.find('.widget-description'));
            widget.off(translationEvent).on(translationEvent, '.widget-description', function () {
                wrapTables($(this));
            });
        },
        destroyView: widget => {
            widget.off(translationEvent);
        },
        initEdit: widget => {
            // Empty for now.
        },
        destroyEdit: widget => {
            // Empty for now.
        }
    };
})();
